<template>
  <div class="my-loader">
    <img src="@/assets/loadingfish.gif" alt="loading..." />
    <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
  props: ["text"]
}
</script>
